<template>
  <div class="news-list">
    <div class="excellentCases">
      <div class="baseContent">
        <div class="carousel-div" v-if="isMobile == 'pc'">
          <!-- <div class="carousel-div-prev">
            <img @click="arrowClick('prev')" src="@/assets/img/fanye-left.png" alt="" class="carousel-icon">
          </div>
          <div class="carousel-div-next">
            <img src="@/assets/img/fanye-right.png" alt="" @click="arrowClick('next')" class="carousel-icon">
          </div> -->
          <!-- <el-row :gutter="10">
            <el-col style="margin-bottom: 2rem" :span="screenWidth>540?12:24" v-for="(item, index) in newsList.filter((items,i)=> i<(screenWidth>540?4:3))" :key="item.id">
              <img :src="item.imgUrl" alt="" width="100%" style="border-radius: 1rem;">
            </el-col>
          </el-row> -->
          <!-- 重写 -->
          <div class="goods-box">
            <div class="list">
              <div class="list-item" v-for="(item, index) in newsList.filter((items,i)=> i<4)" :key="item.id">
                <img :src="item.imgUrl" mode="aspectFill"/>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- 移动端 -->
        <div class="carousel-div-mobile" v-if="isMobile == 'mobile'">
          <!-- <div class="carousel-div-prev">
            <img @click="arrowClick('prev')" src="@/assets/img/fanye-left.png" alt="" class="carousel-icon">
          </div>
          <div class="carousel-div-next">
            <img src="@/assets/img/fanye-right.png" alt="" @click="arrowClick('next')" class="carousel-icon">
          </div> -->
          <el-row :gutter="10">
            <el-col style="margin-bottom: 2rem" :span="screenWidth>540?12:24" v-for="(item, index) in newsList.filter((items,i)=> i<(screenWidth>540?4:3))" :key="item.id">
              <img :src="item.imgUrl" alt="" width="100%" style="border-radius: 1rem;">
              <!-- <div class="img-list" style="width: 100%;background-size: 100% 100%;background-repeat: no-repeat;" :style="{'background-image': 'url('+item.imgUrl+')',}">
              </div> -->
            </el-col>
          </el-row>
        </div>
        
        <div class="more" v-if="isMobile == 'pc'">
          <div class="btn-more" @click="toJump()" style="margin-top: -2rem;z-index: 99;">
            {{$t('ViewAll')}} <i class="el-icon-right"></i>
          </div>
        </div>
        <!-- 移动端 -->
        <div class="more more-mobile" v-if="isMobile == 'mobile'">
          <div class="btn-more" @click="toJump()" style="z-index: 99;margin-bottom:10px;">
            {{$t('ViewAll')}} <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageInfo } from '@/api/index';
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  props: {
    // list: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    moduleId: {
      type: Number,
      default: 24
    },
  },
  data() {
    return {
      page: 1,
      totalPage: 0,
      newsList: [],
    };
  },
  mounted() {
    this.getPrimarySchool()
  },
  methods: {
    getPrimarySchool(page) {
      pageInfo({ "page": page ? page : 1, "size": 4, "moduleId": this.moduleId }).then(res => {
        if (res.data && res.data != null) {
          this.newsList = res.data.records;
          console.log("this.newsList", this.newsList);
          this.totalPage = res.data.pages
        }
      })
    },
    arrowClick(type) {
      if (type === 'prev') {
        if (this.page <= 1) {
          return
        } else {
          this.page--
        }
      } else if (type === 'next') {
        if (this.page >= this.totalPage) {
          return
        } else {
          this.page++
        }
      }

      this.getPrimarySchool(this.page)
    },
    toJump() {
      this.$router.push({
        path: '/kidsGalleryDetail',
        query: {
          id: this.id,
          title: this.title
        },
      });
    },

  },
};
</script>

<style scoped lang="less">
.goods-box {
  overflow: hidden;
}
 
.goods-box .list {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
}
 
.goods-box .list-item {
  width: 33rem;
  border-radius: 8px;
  margin-bottom: 1rem;
}
 
.goods-box .list-item img {
  object-fit: cover;
  width: 100%;
  height: 18rem;
  border-radius: 16px;
}



.excellentCases {
  width: 100%;
  // height: 30rem;
  background: #fdfdfe;
  .baseContent {
  }
}
.look-more {
  width: 8rem;
  padding: 0.5rem;
  background-color: #f8f8f8;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  border-radius: 1.5rem;
}
.news-abstract {
  overflow: hidden;
  line-height: 2rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.carousel-icon {
  width: 2rem;
}
.carousel-div-prev:hover {
  img {
    content: url(../../../../assets/img/fanye-left-hover.png);
  }
}
.carousel-div-next:hover {
  img {
    content: url(../../../../assets/img/fanye-right-hover.png);
  }
}
.carousel-div {
  // height: 10rem;
  // padding: 3%;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
  .carousel-div-prev {
    position: absolute;
    left: -0.5rem;
    top: calc(50% - 1rem);
  }
  .carousel-div-next {
    right: -0.5rem;
    position: absolute;
    top: calc(50% - 1rem);
  }
  img {
    vertical-align: middle;
  }
}

.carousel-div-mobile {
  // height: 10rem;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
  .carousel-div-prev {
    position: absolute;
    left: -0.5rem;
    top: calc(50% - 1rem);
  }
  .carousel-div-next {
    right: -0.5rem;
    position: absolute;
    top: calc(50% - 1rem);
  }
  img {
    vertical-align: middle;
  }
}
.more {
  a {
    text-decoration: none !important;
    color: #221f20 !important;
  }
  // height: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 3rem;
}
.more-mobile{
  margin-top: 0!important;
}

.img-list {
  height: calc(100% - 2rem);
}
</style>